import { Component, OnInit, OnDestroy, ViewChild, Pipe, PipeTransform } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { QuestionService } from '../../shared/web-api/question.service';
import { Translation, TranslationService, Localization, LocaleService } from 'angular-l10n';
import { TreeNode, TreeModel, TreeComponent } from 'angular-tree-component';
import { LanguageService } from '../../shell/language/language.service';
import { Language } from '../../shared/enum/Enumerations';
import { BreadcrumbModule } from '../../shared/custom/breadcrumb/breadcrumb.module';
import { BreadcrumbComponent, Breadcrumb, TreeBreadcrumb } from '../../shared/custom/breadcrumb/breadcrumb.component';
import { environment } from '../../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { AnimationGroupPlayer } from '@angular/animations/src/players/animation_group_player';
import { isNumber } from 'util';


@Pipe({ name: 'sanitizeHtml', pure: true })
export class sanitizeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {
  }

  transform(content) {
    return this.sanitizer.bypassSecurityTrustHtml(content);
  }
}

@Component({
  selector: 'app-questions-view',
  templateUrl: './questions-view.component.html',
  styleUrls: ['./questions-view.component.scss']
})
export class QuestionsViewComponent extends Localization implements OnInit, OnDestroy {
  categoryTree: app.models.QuestionCategoryTreeResult[];
  selectedItem: app.models.QuestionCategoryTreeResult;
  currentLanguageId: number = Language.Romanian;
  selectedNodeWithContent = true;
  questions: app.models.QuestionViewModel[];
  langSubscription: Subscription;
  categoryToActivateId: number;
  categoryId: number;
  categoryHierarchy: app.models.QuestionCategoryTreeResult[] = [];
  @ViewChild(TreeComponent)
  private tree: TreeComponent;
  private questionCodeSearch: number;
  inArchive: boolean = false;
  toggledArchiveText: string = "Arata arhiva";

  details = document.querySelectorAll("details");

  treeBreadcrumbNodes: TreeBreadcrumb[];

  showHideMessage: boolean = true;

  @ViewChild("breadcrumbComponent") breadcrumbComponent: BreadcrumbComponent;
  rowLevel: number = 0;

  treeOptions = {
    isExpandedField: 'expanded'
  }

  constructor(
    private questionService: QuestionService,
    public localization: LocaleService,
    public translation: TranslationService,
    private languageService: LanguageService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    super(localization, translation);
  }

  private questionId: number;
  questionVersions: app.models.QuestionViewModel[];
  ngOnInit() {
    this.route.params
      .subscribe((params: Params) => {
        this.categoryId = +params['categoryId'];
        debugger;

        this.questionId = +params['questionId'];
        if (params['questionId'] == "true" || params['questionId'] == "false") {
          this.inArchive = JSON.parse(params['questionId']);
        }
        if (params['isArchived'] == "true" || params['isArchived'] == "false") {
          this.inArchive = JSON.parse(params['isArchived']);
        }
        if (this.categoryId) {
          this.loadQuestions(this.categoryId);
        }
        if (this.inArchive) {
          this.toggledArchiveText = "Arata spetele publice";
        } else {
          this.toggledArchiveText = "Arata arhiva";
        }
      });
    this.loadCategoryTree();

    this.langSubscription = this.languageService.selectedLangauge.subscribe(x => {

      if (x.languageId != this.currentLanguageId) {
        this.currentLanguageId = x.languageId;
        this.loadCategoryTree();
      }
    });

  }

  searchByQuestionCode() {
    //alert(this.questionCodeSearch);
    this.questionService.getQuestionCategoryByCode(this.questionCodeSearch)
      .subscribe(result => {
        var category = result.data;
        if (category != this.categoryId)
          this.gotoCategoryAndQuestion(category, this.questionCodeSearch);
        else {
          this.questionId = this.questionCodeSearch;
          this.categoryToActivateId = this.categoryId;
          this.activateNode();
        }

      });
  }
  ngOnDestroy() {
    this.langSubscription.unsubscribe();
  }

  loadCategoryTree() {
    this.questionService.getQuestionCategoryTree(this.currentLanguageId, this.inArchive)
      .subscribe(result => {
        this.categoryTree = result.data;
        this.treeBreadcrumbNodes = [];
        if (this.treeBreadcrumbNodes.length == 0) {
          this.treeBreadcrumbNodes.push({ label: "INTERACTIVITATE", url: '/matrix', id: undefined, params: {}, routePattern: undefined });
          this.treeBreadcrumbNodes.push({ label: "Biblioteca de spete", url: '/questions/view', id: undefined, params: {}, routePattern: undefined });
        }
        this.loadNavigation();
        this.activateNode();
      });
  }

  onActivate($event) {
    this.selectedItem = $event.node.data;

    if (this.selectedItem && this.questions && this.selectedItem.id == this.categoryId)
      return;

    this.questions = null;

    // if ($event.node.isExpanded) {
    //   $event.node.collapse();
    // }
    // else {
    //   $event.node.expand();
    // }

    if (this.selectedItem) {
      this.gotoCategory(this.selectedItem.id);
    } else if (isNumber(this.questionId)) {
      this.gotoCategory(this.questionId);
    }
    else {
      if (!$event.node.isExpanded) {
        $event.node.expand();
      }
    }
  }

  gotoCategory(categoryId: number) {
    //debugger;

    this.router.navigateByUrl(`/questions/view/${categoryId}/${this.inArchive}`);
    window.scrollTo(0, 0)
  }

  gotoCategoryAndQuestion(categoryId: number, questionId: number) {
    //debugger;
    this.router.navigateByUrl(`/questions/view/${categoryId}/${questionId}/${this.inArchive}`);
    // alert('ds');
    window.scrollTo(0, 0)

  }

  toggleArchive() {
    this.inArchive = !this.inArchive;
    if (this.inArchive) {
      this.toggledArchiveText = "Arata spetele publice";
    } else {
      this.toggledArchiveText = "Arata arhiva";
    }
    this.categoryTree = [];
    this.selectedItem = null;
    this.categoryToActivateId = null;
    this.questions = [];
    this.categoryHierarchy = [];
    this.treeBreadcrumbNodes = [];
    if (this.treeBreadcrumbNodes.length == 0) {
      this.treeBreadcrumbNodes.push({ label: "INTERACTIVITATE", url: '/matrix', id: undefined, params: {}, routePattern: undefined });
      this.treeBreadcrumbNodes.push({ label: "Biblioteca de spete", url: '/questions/view', id: undefined, params: {}, routePattern: undefined });
    }
    this.questionService.getQuestionCategoryTree(this.currentLanguageId, this.inArchive)
      .subscribe(result => {
        this.categoryTree = result.data;
      });
  }


  loadQuestions(categoryId: number) {
    //debugger;
    this.questionService.getQuestionsByCategoryId(this.currentLanguageId, categoryId, this.inArchive)
      .subscribe(result => {
        this.questions = result.data;
        this.loadNavigation();
        if (!this.selectedItem) {
          this.categoryToActivateId = categoryId;
          this.activateNode();
        }
        window.scrollTo(0, 0)
      });
  }

  closeDetails() {
    $('.versions').click(function (event) {
      $('.versions').not(this).removeAttr("open");
    });
  }

  getPreviousQuestionVersions(questionId: number) {
    this.closeDetails();
    this.questionService.getPreviousQuestionVersions(this.currentLanguageId, questionId)
      .subscribe(result => {
        this.questionVersions = result.data;
      });
  }

  toggleNavigation() {
    var sideBarDiv = document.getElementById("navigationTreeMenuContent");
    if (sideBarDiv.style.display === "none") {
      sideBarDiv.style.display = "block";
      this.showHideMessage = true;
    } else /*if (document.getElementById("matrixContent").style.display !== "none")*/ {
      sideBarDiv.style.display = "none";
      this.showHideMessage = false;
    }
  }

  activateNode() {

    if (!this.categoryToActivateId || !this.categoryTree)
      return;

    setTimeout(() => {
      var node = this.tree.treeModel.getNodeById(this.categoryToActivateId);
      if (node) {

        this.tree.treeModel.setActiveNode(node, true);


        node.focus();
        this.categoryToActivateId = null;

        // new: question:
        if (this.questionId) {
          // debugger;
          var id = "#boxQuestions" + this.questionId;
          var scrollBoxID = "#boxQuestions" + this.questionId;
          var offset = $(scrollBoxID).offset();
          if (offset) {
            var elementOffset = offset.top + 10;

            $(scrollBoxID).animate({
              scrollTop: $(scrollBoxID).scrollTop() + ($(id).offset().top - elementOffset)
            }, 1000);
            $('html, body').animate({
              scrollTop: $(scrollBoxID).offset().top - $('.topbar').height()
            }, 1000);
            this.questionCodeSearch = this.questionId;
            this.questionId = undefined;
          }

        }
      }
    }, 250);
  }

  loadNavigation() {
    if (!this.categoryTree || !this.categoryTree.length || !this.categoryId)
      return;

    //debugger;
    this.categoryHierarchy = this.findNodeInHierarchy(this.categoryId, { children: this.categoryTree, id: 0, parentId: null, name: 'root', isExpanded: true, parentOrder: 0, isTranslatedInCurrentLanguage: true, level: 0, numbering: '0', wbs: '', hasQuestions: false, lastUpdate: undefined });
    console.log(this.categoryHierarchy);
    this.rowLevel = this.categoryHierarchy.length - 1;
    this.treeBreadcrumbNodes = [];
    if (this.treeBreadcrumbNodes.length == 0) {
      this.treeBreadcrumbNodes.push({ label: "INTERACTIVITATE", url: '/matrix', id: undefined, params: {}, routePattern: undefined });
      this.treeBreadcrumbNodes.push({ label: "Biblioteca de spete", url: '/questions/view', id: undefined, params: {}, routePattern: undefined });
    }

    for (let node of this.categoryHierarchy) {

      debugger;
      if (this.questionId) {
        if (this.inArchive) {
          this.treeBreadcrumbNodes.push({ label: node.name, url: `/questions/view/${this.questionId}/true`, id: undefined, params: {}, routePattern: undefined })
        }
        else {
          this.treeBreadcrumbNodes.push({ label: node.name, url: `/questions/view/${this.questionId}`, id: undefined, params: {}, routePattern: undefined })
        }

      }
      else if (this.inArchive) {
        this.treeBreadcrumbNodes.push({ label: node.name, url: `/questions/view/${node.id}/true`, id: undefined, params: {}, routePattern: undefined })
      } else {
        this.treeBreadcrumbNodes.push({ label: node.name, url: `/questions/view/${node.id}`, id: undefined, params: {}, routePattern: undefined })
      }
    }
  }

  findNodeInHierarchy(categoryId: number, parent: app.models.QuestionCategoryTreeResult): app.models.QuestionCategoryTreeResult[] {

    console.log(parent); for (let node of parent.children) {
      console.log(node);

      if (node.id == categoryId) {
        return [node];
      }
      let found = this.findNodeInHierarchy(categoryId, node);
      if (found.length)
        return [node, ...found];
    }
    return [];
  }

  searchByTag(nume: string) {
    // alert('a');

    if (environment.iwBase) {
      window.location.href = `${environment.iwBase}/search?q=${nume}&t=3&z=0`;
    }
    else {
      this.router.navigateByUrl('/home', { skipLocationChange: true }).then(x => {
        this.router.navigateByUrl(`/search?q=${nume}&t=3&z=0`);
      });
    }
    // this.router.navigate(["Landing"]);

  }
}



// WEBPACK FOOTER //
// ./src/app/questions/questions-view/questions-view.component.ts